/**
 * Sanitizes string from extra chars elements
 *
 * @param {*} str
 */
export const sanitize = str => str.replace(/&#(\d+);/g, (match, dec) => String.fromCharCode(dec))
